document.addEventListener('turbo:load', function() {
    const paymentModal = document.getElementById('paymentModal');
    const modalTotalAmountDisplay = document.getElementById('modal-total-amount');
    const paidAmountInput = document.getElementById('paid-amount-input');
    const changeDisplay = document.getElementById('change-display');
    const keypadButtons = document.querySelectorAll('.numeric-keypad button');

    // 支払い金額をカンマや通貨記号なしの純粋な文字列として保持します
    let currentPaidAmountString = ''; 

    // グローバル変数が正しくロードされているか確認します。
    // これらの変数は、このスクリプトタグより前のERB部分で定義されている必要があります。
    if (typeof totalAmountValue === 'undefined' || typeof totalAmountFormatted === 'undefined' || typeof currentLocale === 'undefined' || typeof translations === 'undefined') {
        console.warn("Payment calculation JS: Required global variables are missing or not correctly loaded.");
        return; // 変数がなければ処理を中断します
    }

    // モーダルが表示される直前のイベントリスナー
    paymentModal.addEventListener('show.bs.modal', function () {
        modalTotalAmountDisplay.textContent = totalAmountFormatted; // 合計金額を表示
        currentPaidAmountString = ''; // 支払い金額の内部文字列をクリア
        paidAmountInput.value = ''; // 支払い金額の表示もクリア
        updateChangeDisplay(); // お釣りの初期表示を更新
        paidAmountInput.focus(); // 支払い金額入力フィールドにフォーカスを設定
    });

    // モーダルが閉じられる直前のイベントリスナー
    paymentModal.addEventListener('hide.bs.modal', function() {
        currentPaidAmountString = ''; // 支払い金額の内部文字列をクリア
        paidAmountInput.value = ''; // 支払い金額の表示もクリア
        updateChangeDisplay(); // お釣りの表示をリセット
    });

    // テンキーのクリックイベントを処理
    keypadButtons.forEach(button => {
        button.addEventListener('click', function() {
            const key = this.dataset.key; // 押されたキーの値を取得します
            
            if (key === 'clear') {
                currentPaidAmountString = ''; // 全てクリア
            } else if (key === 'backspace') {
                currentPaidAmountString = currentPaidAmountString.slice(0, -1); // 最後の文字を削除
                // backspace で文字列が空になったら、入力フィールドをクリアし、お釣りを更新して終了します
                if (currentPaidAmountString === '') {
                    paidAmountInput.value = '';
                    updateChangeDisplay();
                    return; 
                }
            } else if (key === '.') {
                // 既に小数点が含まれていない場合のみ追加します
                if (!currentPaidAmountString.includes('.')) {
                    // 空文字列の場合に '.' を押したら "0." にします（電卓の一般的な挙動）
                    if (currentPaidAmountString === '') {
                        currentPaidAmountString = '0.';
                    } else {
                        currentPaidAmountString += key;
                    }
                } else {
                    // 既に小数点がある場合は何もしません（重複を防ぐため）
                    updateChangeDisplay(); // 念のためお釣りを更新
                    return; 
                }
            } else { // 数字キーの場合
                // 先頭が '0' かつ次のキーが数字の場合に '0' をその数字で置き換えます（例: '0' -> '5' で '5' に）
                if (currentPaidAmountString === '0' && key !== '.') {
                    currentPaidAmountString = key; 
                } else {
                    currentPaidAmountString += key;
                }
            }

            // ★お支払い金額の表示を更新するロジック★
            // input type="text" なので、currentPaidAmountString をそのまま設定します
            paidAmountInput.value = currentPaidAmountString;
            
            updateChangeDisplay(); // 入力値が変わるたびにお釣りを更新します
        });
    });

    // お釣りを計算・表示する関数
    function updateChangeDisplay() {
        // 計算には純粋な数値文字列を使用します
        const paidAmount = parseFloat(currentPaidAmountString);
        let change = 0;
        // ユーザーの閲覧ロケールに基づいて通貨記号を決定します
        const currencySymbol = (currentLocale === 'en' || currentLocale === 'en-US') ? '$' : '￥'; 

        if (!isNaN(paidAmount) && paidAmount >= totalAmountValue) {
            // お釣りがプラスまたはゼロの場合
            change = paidAmount - totalAmountValue;
            changeDisplay.textContent = currencySymbol + change.toLocaleString(currentLocale === 'en' ? 'en-US' : 'ja-JP', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
            changeDisplay.style.color = ''; // デフォルトの色に戻します
        } else if (!isNaN(paidAmount) && paidAmount < totalAmountValue) {
            // 支払い金額が不足している場合
            const deficit = totalAmountValue - paidAmount;
            changeDisplay.textContent = `${translations.insufficientAmount}: ${currencySymbol}${deficit.toLocaleString(currentLocale === 'en' ? 'en-US' : 'ja-JP', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
            changeDisplay.style.color = 'red'; // 赤色で表示します
        } else {
            // 無効な入力（NaN）または未入力の場合
            changeDisplay.textContent = currencySymbol + '0';
            changeDisplay.style.color = ''; // デフォルトの色に戻します
        }
    }
});